import React from 'react'
import { Link, graphql, StaticQuery } from 'gatsby'
import Img from 'gatsby-image'
import IconUser from '../icons/user.svg'
import IconTwitter from '../icons/twitter.svg'
import IconFacebook from '../icons/facebook.svg'
import IconLink from '../icons/link.svg'
import IconLocation from '../icons/location.svg'

function AboutAuthor({ avatar, author }) {
	return (
		<div className="about-author-section text-center">
			<div className="section-title h5 text-center">
				This post was written by:
			</div>
			<div className="about-author-wrap d-flex flex-wrap">
				<div className="about-author text-center d-flex flex-column flex-grow-1">
					{avatar ? (
						<a
							href={author.website}
							title={author.name}
							rel="noopener noreferrer"
						>
							<Img
								fixed={avatar.childImageSharp.fixed}
								alt="Author image"
								className="avatar"
							/>
						</a>
					) : (
						<a
							href={author.website}
							title={author.name}
							rel="noopener noreferrer"
						>
							<div className="avatar no-image ml-auto mr-auto">
								<IconUser />
							</div>
						</a>
					)}
					<h3 className="name h4">
						<a href={author.website} rel="noopener noreferrer">
							{author.name}
						</a>
					</h3>
					<ul className="meta-info">
						{author.twitter && (
							<li>
								<a
									href={author.twitter}
									target="_blank"
									rel="noopener noreferrer"
								>
									<IconTwitter />
								</a>
							</li>
						)}
						{!!author.facebook && (
							<li>
								<a
									href={author.facebook}
									target="_blank"
									rel="noopener noreferrer"
								>
									<IconFacebook />
								</a>
							</li>
						)}
						{!!author.website && (
							<li>
								<a
									href={author.website}
									target="_blank"
									rel="noopener noreferrer"
								>
									<IconLink />
								</a>
							</li>
						)}
						{!!author.location && (
							<li className="location">
								<IconLocation />
								{author.location}
							</li>
						)}
					</ul>

					{author.bio && <div className="bio">{author.bio}</div>}
					<div className="permalink">
						<Link to={`/`}>See all post by {author.name}</Link>
					</div>
				</div>
			</div>
		</div>
	)
}

const aboutAuthorQuery = graphql`
	{
		allSite {
			nodes {
				siteMetadata {
					themeOptions {
						author {
							name
							twitter
						}
					}
				}
			}
		}
	}
`

function StaticAboutAuthor({ avatar }) {
	return (
		<StaticQuery
			query={aboutAuthorQuery}
			render={data => (
				<AboutAuthor
					avatar={avatar}
					author={data.allSite.nodes[0].siteMetadata.themeOptions.author}
				/>
			)}
		/>
	)
}

export default StaticAboutAuthor
